import { render, staticRenderFns } from "./tableapi.vue?vue&type=template&id=1ebb156d&"
import script from "./tableapi.vue?vue&type=script&lang=js&"
export * from "./tableapi.vue?vue&type=script&lang=js&"
import style0 from "./tableapi.vue?vue&type=style&index=0&id=1ebb156d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports